import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-xxl-10 offset-xxl-2 col-xl-9 offset-xl-3 overflow-x-hidden" }
const _hoisted_2 = { class: "m-lg-5 mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_side_bar = _resolveComponent("side-bar")!
  const _component_dashboard = _resolveComponent("dashboard")!
  const _component_pension_management = _resolveComponent("pension-management")!
  const _component_providers = _resolveComponent("providers")!
  const _component_advisers = _resolveComponent("advisers")!
  const _component_guaranteedIncome = _resolveComponent("guaranteedIncome")!
  const _component_statePensionHelp = _resolveComponent("statePensionHelp")!
  const _component_lumpsSumsAndTax = _resolveComponent("lumpsSumsAndTax")!
  const _component_benefitsAndCredits = _resolveComponent("benefitsAndCredits")!
  const _component_equityRelease = _resolveComponent("equityRelease")!
  const _component_partnersIncome = _resolveComponent("partnersIncome")!
  const _component_helpAndEducation = _resolveComponent("helpAndEducation")!
  const _component_otherWaysToSave = _resolveComponent("otherWaysToSave")!
  const _component_financialCoaching = _resolveComponent("financialCoaching")!
  const _component_whyPayMore = _resolveComponent("whyPayMore")!
  const _component_retirementChoicesHL = _resolveComponent("retirementChoicesHL")!
  const _component_lumpSumsHL = _resolveComponent("lumpSumsHL")!
  const _component_mixingOptionsHL = _resolveComponent("mixingOptionsHL")!
  const _component_guaranteedIncomeHL = _resolveComponent("guaranteedIncomeHL")!
  const _component_adviserHL = _resolveComponent("adviserHL")!
  const _component_flexibleIncomeHL = _resolveComponent("flexibleIncomeHL")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_side_bar, {
      selectedView: _ctx.selectedView,
      onItemSelected: _ctx.onNavItemSelected
    }, null, 8, ["selectedView", "onItemSelected"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showDashboard)
          ? (_openBlock(), _createBlock(_component_dashboard, {
              key: 0,
              showPageNav: false,
              headerText: "Our dashboard tracker below shows you everything you have to use and if your plan is still expected to work under various scenarios. You can edit anything you have here. On the left hand side, there is a menu for help on various elements, which can help you improve your retirement outcome.",
              onGuaranteedIncomeChangeRequired: _ctx.onShowGuaranteedIncomeEditor
            }, null, 8, ["onGuaranteedIncomeChangeRequired"]))
          : _createCommentVNode("", true),
        (_ctx.showPensionManagement)
          ? (_openBlock(), _createBlock(_component_pension_management, { key: 1 }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_providers, {
          ref: "providers",
          onRedirectRequired: _ctx.onRedirectFromProviders
        }, null, 8, ["onRedirectRequired"]), [
          [_vShow, _ctx.showProviders]
        ]),
        (_ctx.showAdvisers)
          ? (_openBlock(), _createBlock(_component_advisers, { key: 2 }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_guaranteedIncome, { ref: "guaranteedIncome" }, null, 512), [
          [_vShow, _ctx.showGuaranteedIncome]
        ]),
        _withDirectives(_createVNode(_component_statePensionHelp, { ref: "statePension" }, null, 512), [
          [_vShow, _ctx.showStatePensionHelp]
        ]),
        (_ctx.showLumpsSumsAndTax)
          ? (_openBlock(), _createBlock(_component_lumpsSumsAndTax, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.showBenefitsAndCredits)
          ? (_openBlock(), _createBlock(_component_benefitsAndCredits, { key: 4 }))
          : _createCommentVNode("", true),
        (_ctx.showEquityRelease)
          ? (_openBlock(), _createBlock(_component_equityRelease, { key: 5 }))
          : _createCommentVNode("", true),
        (_ctx.showPartnersIncome)
          ? (_openBlock(), _createBlock(_component_partnersIncome, { key: 6 }))
          : _createCommentVNode("", true),
        (_ctx.showHelpAndEducation)
          ? (_openBlock(), _createBlock(_component_helpAndEducation, { key: 7 }))
          : _createCommentVNode("", true),
        (_ctx.showOtherWaysToSave)
          ? (_openBlock(), _createBlock(_component_otherWaysToSave, { key: 8 }))
          : _createCommentVNode("", true),
        (_ctx.showFinancialCoaching)
          ? (_openBlock(), _createBlock(_component_financialCoaching, { key: 9 }))
          : _createCommentVNode("", true),
        (_ctx.showWhyPayMore)
          ? (_openBlock(), _createBlock(_component_whyPayMore, { key: 10 }))
          : _createCommentVNode("", true),
        (_ctx.showRetirementChoicesHL)
          ? (_openBlock(), _createBlock(_component_retirementChoicesHL, { key: 11 }))
          : _createCommentVNode("", true),
        (_ctx.showLumpSumsHL)
          ? (_openBlock(), _createBlock(_component_lumpSumsHL, { key: 12 }))
          : _createCommentVNode("", true),
        (_ctx.showMixingOptionsHL)
          ? (_openBlock(), _createBlock(_component_mixingOptionsHL, { key: 13 }))
          : _createCommentVNode("", true),
        (_ctx.showGuaranteedIncomeHL)
          ? (_openBlock(), _createBlock(_component_guaranteedIncomeHL, { key: 14 }))
          : _createCommentVNode("", true),
        (_ctx.showAdviserHL)
          ? (_openBlock(), _createBlock(_component_adviserHL, { key: 15 }))
          : _createCommentVNode("", true),
        (_ctx.showFlexibleIncomeHL)
          ? (_openBlock(), _createBlock(_component_flexibleIncomeHL, { key: 16 }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}